import React, {CSSProperties} from "react";
import {observer} from "mobx-react";
import {IBookingViewModel} from "../../../services/booking/models/booking-view-model.interface";
import {
    IJourneyShoppingCartViewModel
} from "../../../services/booking/models/shopping-cart/journey/journey-shopping-cart-view-model.interface";
import {useServices} from "../../../hooks/use-services.hook";
import {getPageVerticalGap} from "../print-ticket.helpers";
import {TicketJourneyDetailsComponent} from "./ticket-journey-details.component";
import {TicketJourneyFaresComponent} from "./ticket-journey-fares.component";
import {TicketJourneyExtrasComponent} from "./ticket-journey-extras.component";
import {TicketJourneyGrandTotalComponent} from "./ticket-journey-grand-total.component";

interface TicketJourneyCartComponentProps {
    booking: IBookingViewModel;
    journeyCart: IJourneyShoppingCartViewModel;
    printDate: Date;
    isLastOne: boolean;
}

export const TicketJourneyComponent: React.FC<TicketJourneyCartComponentProps> = observer((props) => {
    const services = useServices();
    const theme = services.theme.currentTheme;
    const styles: CSSProperties = {
        display: "flex",
        flexDirection: "column",
        gap: getPageVerticalGap(theme),
        width: '100%'
    };

    if(!props.isLastOne) {
        styles.pageBreakAfter = 'always';
        styles.breakAfter = "always";
    }

    return (
        <section style={styles}>
            <TicketJourneyDetailsComponent journeyCart={props.journeyCart}/>
            <TicketJourneyFaresComponent journeyCart={props.journeyCart}/>
            <TicketJourneyExtrasComponent journeyCart={props.journeyCart}/>
            <TicketJourneyGrandTotalComponent journeyCart={props.journeyCart}/>
        </section>
    );
})

